module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-left-pagination-f414d333bcb453b1bebc4a6fa7d1763b.svg";